import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const bathMaid: NarratorNPC = {
  id: 'bathmaid',
  name: 'Bathmaid',
  dialog: dialog,
};
